import React from 'react';

import type { InterpretationSnapshotListItem } from '../redux';

type InterpretationSnapshotsListProps = {
  snapshots: InterpretationSnapshotListItem[];
};

const snapshotUrl = (snapshotId: number, variantId: number) => {
  const url = new URL(window.location.origin);
  url.pathname = `/variant-workflow/${variantId}/interpretation`;
  url.searchParams.set('interpretation_snapshot', String(snapshotId));
  return url.toString();
};

const snapshotValue = (value: string | number | null) => value ?? '-';

const InterpretationSnapshotsList = ({
  snapshots,
}: InterpretationSnapshotsListProps) => {
  if (snapshots.length === 0) {
    return null;
  }

  return (
    <section className="interpretation-snapshots" data-snapshot-exclude="true">
      <h3>Previous interpretations</h3>
      <div className="interpretation-snapshots__items">
        {snapshots.map((snapshot) => (
          <a
            className="interpretation-snapshots__item"
            href={snapshotUrl(snapshot.id, snapshot.variant_id)}
            key={snapshot.id}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="interpretation-snapshots__clinical-interpretation">
              Clinical interpretation:{' '}
              {snapshotValue(snapshot.clinical_interpretation)}
            </div>
            <div>
              Last interpreted on: {snapshotValue(snapshot.interpreted)}
            </div>
            <div>
              Last interpreted by: {snapshotValue(snapshot.interpreted_by)}
            </div>
            <div>Confirmed: {snapshotValue(snapshot.confirmations)}</div>
            <div>Posterior probability: {snapshotValue(snapshot.post_p)}</div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default InterpretationSnapshotsList;
